import React, {useEffect} from "react";
import {ReactComponent as ShopIcon} from "assets/images/icon/shopIcon.svg";
import {ReactComponent as MenuIcon} from "assets/images/icon/menuIcon.svg";
import {ReactComponent as ManageIcon} from "assets/images/icon/manageIcon.svg";
import {ReactComponent as OrderIcon} from "assets/images/icon/orderIcon.svg";
import {ReactComponent as ShopCloseIcon} from "assets/images/icon/shopCloseIcon.svg";
import {ReactComponent as CsIcon} from "assets/images/icon/csIcon.svg";
import {getParameter, openPopup} from "utils/CommonUtils";
import {AlertMessagePopup} from "../popup/AlertMessagePopup";
import {useNavigate} from "react-router-dom";
import ShopStopPopup from "../popup/ShopStopPopup";

const SubNavigate = React.memo(() => {
  const navigate = useNavigate();

  const handleUrlLink = (url) => {
    const shopId = getParameter("shopId");
    const shopUrl = shopId ? `?shopId=${shopId}` : "";

    navigate(`${url}${shopUrl}`);
  }

  useEffect(() => {
    const subNavUls = document.querySelectorAll('.subNavUl');

    subNavUls.forEach(function(subNavUl) {
      subNavUl.addEventListener('click', function() {
        if (!this.classList.contains('active')) {
          subNavUls.forEach(function(otherSubnavUl) {
            otherSubnavUl.classList.remove('active');
          });
          this.classList.add('active');
        }
      });
    });

    window.addEventListener('resize', function() {
      if (window.innerWidth > 700) {
        document.getElementById("subNavigateHide").classList.remove("active");
        document.getElementById("subNavigate").classList.remove("active");
      }
    });

  }, []);

  return (
    <>
      <AlertMessagePopup id="cuponErrorPopup" title="" text="준비 중입니다."/>
      <ShopStopPopup />

      <div id="subNavigateHide" className="subNavigateHide"></div>
      <div id="subNavigate" className="subNavigate bg-blue">
        <nav className="subNavBox ml-10 pt-10 scrollbar">
          <ul className="subNavUl shopNav">
            <div className="subNavTitle d-flex j-left a-center fw-7 fs-18 pl-15 fc-white pointer">
              <ShopIcon width={19} />
              <span className="ml-15">상점 관리</span>
            </div>
            <li className="subNav shop1 pt-5 pb-5 pl-30 pointer" onClick={() => handleUrlLink("/v2/shopInfo1")}>
              상점 정보 관리
            </li>
          </ul>
          <ul className='subNavUl menuNav'>
            <div className='subNavTitle d-flex j-left a-center fw-7 fs-18 pl-15 fc-white pointer'>
              <MenuIcon width={19} />
              <span className="ml-15">메뉴 관리</span>
            </div>
            <li className='subNav menu1 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/menuList")}>
              메뉴/그룹 관리
            </li>
            <li className='subNav menu2 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/optionList")}>
              옵션 관리
            </li>
            <li className='subNav menu3 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/menuOrigin")}>
              원산지
            </li>
          </ul>
          <ul className='subNavUl manageNav'>
            <div className='subNavTitle d-flex j-left a-center fw-7 fs-18 pl-15 fc-white pointer'>
              <ManageIcon width={19} />
              <span className="ml-15">운영 관리</span>
            </div>
            <li className='subNav manage1 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/review")}>
              리뷰 관리
            </li>
            <li className='subNav manage2 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/coupon")}>
              쿠폰 관리
            </li>
            <li className='subNav manage3 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/user")}>
              계정 관리
            </li>
          </ul>
          <ul className='subNavUl calculateNav' >
            <div className='subNavTitle d-flex j-left a-center fw-7 fs-18 pl-15 fc-white pointer'>
              <OrderIcon width={19} />
              <span className="ml-15">정산 관리</span>
            </div>
            <li className='subNav calculate1 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/orderList")}>
              주문 내역
            </li>
            <li className='subNav calculate2 pt-5 pb-5 pl-30 pointer' onClick={() => window.open("https://my.ciderpay.com/login")}>
              사이다페이
            </li>
            <li className='subNav calculate3 pt-5 pb-5 pl-30 pointer' onClick={() => handleUrlLink("/v2/statistics")}>
              통계
            </li>
          </ul>
          {/* * 해당 기능 미동작으로  주석 처리*/}
          {/* <button type='button' className='flexBox stopPopupBtn left fc-white fw-7 fs-17 mt-10 mb-20' onClick={() => openPopup("stopChoicePopup")}>
            <ShopCloseIcon/>
            <span className="ml-5">영업일시중지</span>
          </button> */}
        </nav>
        <footer className="footer bg-white pl-10" style={{ paddingBottom: '7rem' }}>
          <div className='d-flex a-center j-left pt-10'>
            <CsIcon width={20} />
            <p className='csNumber ml-5 fs-22 fw-7 fc-blue'>1800-9991</p>
          </div>
          <div>
            <p className='csSchedule fs-14'>
              평일 10:00 ~ 19:00
              <br/>
              {/* 주말/공휴일 11:00 ~ 20:00 */}
            </p>
          </div>
        </footer>
      </div>
    </>
  );
});

export default SubNavigate;